
<template>
    <div class="video">
        <div class="video__wrapper" :style="{ paddingBottom: aspectRatio }">
            <video
                ref="video"
                class="video__player"
                preload="auto"
                :poster="poster"
                :controls="settings.controls"
                :autoplay="settings.autoplay"
                :loop="settings.loop"
                :muted="settings.muted"
                :playsinline="settings.playsinline"
                >
                <source :src="url" type="video/mp4">
            </video>
        </div>
    </div>
</template>

<script>
import objectFitVideos from 'object-fit-videos';

export default {
    name: 'VideoElement',
    props: {
        url: {
            type: String,
            required: true
        },
        poster: {
            type: String,
            default: null
        },
        settings: {
            type: Object,
            default: () => {
                return {
                    controls: true,
                    autoplay: false,
                    loop: false,
                    muted: false,
                    playsinline: false,
                }
            }
        }
    },
    data() {
        return {
            aspectRatio: (9/16 * 100) + '%'
        }
    },
    mounted() {
        const { video } = this.$refs;
        objectFitVideos();
        video.addEventListener('loadedmetadata', this.setAspectRatio, { once: true });
    },
    methods: {
        setAspectRatio() {
            const { video } = this.$refs;
            this.aspectRatio = `${video.videoHeight / video.videoWidth * 100}%`;
        }
    }
}
</script>
